var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signin"},[_c('button',{on:{"click":_vm.signIn}},[_c('img',{attrs:{"src":"https://github.githubassets.com/favicons/favicon-dark.png"}}),_c('span',[_vm._v("Sign up with GitHub")])])])}
var staticRenderFns = []

export { render, staticRenderFns }